export const GlobalEventLoader = window.o_global?.eventLoader;
